module.exports = __webpack_public_path__ + "./images/p21.JPG?2afcef954e42e9f7b8dcbfac9aa0e54f";


//////////////////
// WEBPACK FOOTER
// ./src/products/p21.JPG
// module id = 57
// module chunks = 0